<div class="flex flex-wrap mt-8">

    @let session = (session$ | async);

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo=".."></app-btn-back>
    </div>

    <div class="mb-4 border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-blueGray-700">
            {{session?.sessionName}}
        </h1>
    </div>

    <div class="relative flex flex-col w-full mb-6 shadow-lg rounded bg-white p-4">

        <div class="rounded-t block w-full overflow-x-auto">
            <div class="flex flex-row gap-4">
                <div class="w-full mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Start Date Time
                    </label>
                    @if (session?.startDate) {
                    <span class="text-blueGray-600 text-sm">{{session!.startDate!.toDate() | moment: 'HH:mm a Do MMM
                        YYYY'}}</span>
                    } @else {
                    <span class="text-blueGray-600 text-sm">Unknown</span>
                    }
                </div>
                <div class="w-full mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        End Date Time
                    </label>
                    @if (session?.endDate) {
                    <span class="text-blueGray-600 text-sm">{{session!.endDate!.toDate() | moment: 'HH:mm
                        a Do MMM YYYY'}}</span>
                    } @else {
                    <span class="text-blueGray-600 text-sm">Unknown</span>
                    }
                </div>
            </div>

        </div>
    </div>

    <div class="relative flex flex-col w-full mt-4 mb-6 shadow-lg rounded bg-white p-4"></div>

</div>